import React from 'react';

import { ImagePlaceholder } from '@dutchie/backoffice-ui-library';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { BrandImage, BrandNameAndImage, BrandPlacholderImage } from './styled';
import { BrandRow } from './types';

export const BrandNameAndImageCell = (
  params: GridRenderCellParams<BrandRow>,
) => {
  return (
    <BrandNameAndImage>
      {params.row.imageUrl && (
        <BrandImage src={params.row.imageUrl} alt={params.row.name} />
      )}
      {!params.row.imageUrl && (
        <BrandPlacholderImage>
          <ImagePlaceholder />
        </BrandPlacholderImage>
      )}
      <span>{params.row.name}</span>
    </BrandNameAndImage>
  );
};
